<template>
  <v-dialog
    v-model="opened"
    width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
    persistent
    lazy
    @keydown.enter="send()"
    v-if="signatureRequest"
  >
    <v-card block flat class="text-xs-left">
      <v-card-title class="title pt-4 pb-0"> Send </v-card-title>

      <v-card-text vclass="text-xs-left">
        <span>Subject</span>
        <v-text-field
          class="default-input mt-1 pb-3"
          v-model="sendReturnOptions.subject"
          solo
          hide-details
        />

        <span>Message</span>
        <quill-editor
          v-model="sendReturnOptions.message"
          :options="editorOption"
          class="message-input mt-2 pb-2 default-input"
        />

        <v-layout mt-1>
          <span
            >Path: <b>/{{ signatureRequest.tax_year }}</b></span
          >
        </v-layout>

        <v-layout mt-3>
          <v-flex xs-12>
            <span>Document Name</span>
            <v-text-field
              class="default-input mt-1 pb-3"
              v-model="sendReturnOptions.documentName"
              solo
              hide-details
            />
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn class="primary text-none" @click="send()" :loading="sending">
          Send
        </v-btn>
        <v-btn
          class="error--text text-none"
          flat
          @click="$emit('update:opened', false)"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    opened: {
      type: Boolean,
    },

    signatureRequest: {
      type: Object,
    },

    sending: {
      type: Boolean,
    },
  },

  data() {
    return {
      mode: 0,

      editorOption: {
        formats: ['bold', 'italic', 'underline', 'link', 'indent', 'list'],
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ indent: '-1' }, { indent: '+1' }],
            ['link'],
            [{ list: 'ordered' }, { list: 'bullet' }],
          ],
        },
        placeholder: 'Message',
        bounds: '.message-input',
      },

      sendReturnOptions: {
        subject: '',
        message: '',
        path: '',
        documentName: '',
        saveSubjectForFutureUse: false,
        saveMessageForFutureUse: false,
      },
    };
  },

  computed: {
    ...mapGetters({
      currentFirm: 'currentFirm',
      currentUser: 'user',
    }),
  },

  methods: {
    send() {
      this.$emit('send', {
        mode: 1,
        ...this.sendReturnOptions,
      });
    },

    reset() {
      this.sendReturnOptions.subject =
        'Your {tax_year} Individual Return has been e-filed and uploaded under your {document_path} folder';

      this.sendReturnOptions.message = `<p>Hi {client_preferred_name},</p><p>Your {tax_year} tax return has been e-filed. We saved the return as "{document_name}" under folder {document_path}. We will let you know if there are any other action items.</p><p>Best regards,</p><p>${this.currentUser.full_name}</p>`;

      this.sendReturnOptions.path = '/' + this.signatureRequest.tax_year;

      this.sendReturnOptions.documentName = this.signatureRequest.form_name;
    },
  },

  watch: {
    opened: {
      async handler(value) {
        if (value) {
          this.reset();
        }
      },
    },
  },
};
</script>

<style lang="postcss" scoped>
.message-input {
  & >>> .ql-container .ql-editor {
    min-height: 80px;
    max-height: 25vh;
  }

  & >>> .ql-container .ql-editor p,
  & >>> .ql-container .ql-editor ul {
    padding-bottom: 12px;
  }
}
</style>
